import { useNavigate, useParams } from 'react-router-dom';
import PackageForm from './package-form/PackageForm';
import LoadingContainer from 'components/common/LoadingContainer';
import paths from 'routes/paths';
import { usePackage, useUpdatePackage } from 'hooks/useDonationSettings';

function EditPackage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { package: packageData, isLoading: dataLoading } = usePackage(id);
  const { updatePackage, isUpdating: editLoading } = useUpdatePackage();

  const onSubmit = async (data) => {
    try {
      await updatePackage({
        id,
        data
      });
      navigate(paths.donationPackages);
    } catch (error) {
      console.error(error);
    }
  };

  return dataLoading ? (
    <LoadingContainer />
  ) : (
    <PackageForm
      onSubmit={onSubmit}
      loading={editLoading}
      isEdit
      data={packageData}
    />
  );
}

export default EditPackage;
